import { render } from "./AccountActivatorView.vue?vue&type=template&id=70a75c97"
import script from "./AccountActivatorView.vue?vue&type=script&lang=js"
export * from "./AccountActivatorView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__